<template>
  <TextInput
    v-model="titleCopy"
    v-validate="'required|max:100'"
    :read-only="isTournamentFieldDisabled('title')"
    :disabled="isTournamentFieldDisabled('title')"
    :maxlength="100"
    required
    :label="$$t('Tournament Name:', 'name-label')"
    :placeholder="$$t('Tournament name', 'name-placeholder')"
    :error="errors.first('title')"
    :data-vv-as="$$t('Tournament Name', 'name-label')"
    data-vv-name="title"
    class="mb-5"
    @change="val => (title = val)"
  />
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import TextInput from '@/components/atoms/form/HeraFormTextInput';
import { translate } from '@/mixins/translate';
export default {
  name: 'TournamentTitleSetting',
  inject: ['$validator'],
  components: {
    TextInput,
  },
  mixins: [translate('_web_tournament_settings')],
  data() {
    return {
      titleCopy: '',
    };
  },
  computed: {
    ...mapGetters(['currentTournament', 'isTournamentFieldDisabled']),
    title: {
      get() {
        return this.$lodash.get(this.currentTournament, 'info.title', '');
      },
      set(newVal) {
        this.updateCurrentTournament({
          title: newVal,
          component: 'info',
        });
      },
    },
  },
  watch: {
    'currentTournament.id'() {
      this.initTitle();
    },
    'currentTournament.info.game'() {
      this.initTitle();
    },
  },
  created() {
    if (this.$route.params.tournamentID) {
      this.initTitle();
    }
  },
  methods: {
    ...mapMutations(['updateCurrentTournament']),
    initTitle() {
      this.titleCopy = this.title;
    },
  },
};
</script>
